import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
  IconButton,
  Tooltip,
  Button
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ApprovedPolicyListPage = () => {
  const navigate = useNavigate();

  // Mock data for approved policies
  const approvedPolicies = [
    {
      id: 1,
      policyNumber: 'POL-2024-001',
      type: 'Auto Insurance',
      client: 'John Smith',
      approvedDate: '2024-01-20',
      complexity: 'simple',
      underwriter: 'Sarah Wilson'
    },
    {
      id: 2,
      policyNumber: 'POL-2024-002',
      type: 'Home Insurance',
      client: 'Emma Johnson',
      approvedDate: '2024-01-21',
      complexity: 'moderate',
      underwriter: 'Michael Brown'
    },
    {
      id: 3,
      policyNumber: 'POL-2024-003',
      type: 'Commercial Insurance',
      client: 'ABC Company',
      approvedDate: '2024-01-22',
      complexity: 'complex',
      underwriter: 'David Lee'
    }
  ];

  const getComplexityChip = (complexity) => {
    const config = {
      simple: { color: 'success', label: 'Simple' },
      moderate: { color: 'warning', label: 'Moderate' },
      complex: { color: 'error', label: 'Complex' }
    };

    return (
      <Chip
        size="small"
        color={config[complexity].color}
        label={config[complexity].label}
        variant="outlined"
      />
    );
  };

  return (
    <Container maxWidth="xl">
      {/* Header Section */}
      <Box sx={{ 
        pt: 4,
        pb: 3,
        textAlign: 'center',
        position: 'relative',
        borderBottom: '1px solid #e0e0e0',
        mb: 4
      }}>
        <Button
          variant="outlined"
          onClick={() => navigate('/underwriter')}
          startIcon={<ArrowBackIcon />}
          sx={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#1976d2',
            borderColor: '#1976d2',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: 'rgba(25, 118, 210, 0.04)'
            }
          }}
        >
          Back to Dashboard
        </Button>

        <Typography 
          variant="h4" 
          sx={{ 
            color: '#1976d2',
            fontWeight: 600,
            mb: 1
          }}
        >
          Approved Policies
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            color: '#666',
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          View all approved insurance policies and their details
        </Typography>
      </Box>

      {/* Table Section */}
      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 600 }}>Policy Number</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Client</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Approved Date</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Complexity</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Underwriter</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {approvedPolicies.map((policy) => (
              <TableRow 
                key={policy.id}
                sx={{ 
                  '&:hover': { 
                    bgcolor: '#f8f9fa',
                  },
                  transition: 'background-color 0.2s'
                }}
              >
                <TableCell>{policy.policyNumber}</TableCell>
                <TableCell>{policy.type}</TableCell>
                <TableCell>{policy.client}</TableCell>
                <TableCell>{policy.approvedDate}</TableCell>
                <TableCell>{getComplexityChip(policy.complexity)}</TableCell>
                <TableCell>{policy.underwriter}</TableCell>
                <TableCell>
                  <Tooltip title="View Details">
                    <IconButton 
                      size="small"
                      onClick={() => navigate(`/underwriter/approved/${policy.id}`)}
                      sx={{ color: '#1976d2' }}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ApprovedPolicyListPage; 